module.exports = __webpack_public_path__ + "static/media/decline-icon.61afa965.svg";